import React from 'react';
import { Outlet } from 'react-router-dom';

export function MidleWare() {
  return <Outlet />;
}

export function AllowedFunc() {
  return false;
}

export function SideMenuAccess() {
  return true;
}
